<template>
  <el-dialog v-if="visible" :close-on-click-modal="false" title="Cash Transaction Info" :model-value="visible"
    @update:modelValue="visible = $event" :before-close="handleClose" width="50%">

    <el-form v-if="isBalanceOnly" :model="cashTransaction" :rules="rules" ref="formRef" label-width="150px"
      size="small">
      <el-form-item label="Amount: " prop="amount">
        <el-input type="number" v-model="cashTransaction.amount" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="For Currency" prop="forCurrency">
        <el-row :gutter="30">
          <el-col :span="8">
            <el-select style="min-width: 100px;" v-model="cashTransaction.forCurrency">
              <el-option v-for="item in usdMmkOption.toList().filter(o => [1, 2].includes(o.id))" :key="item.id"
                :label="item.name" :value="item.id" />
            </el-select>
          </el-col>
          <el-col v-if="cashTransaction.forCurrency == usdMmkOption.USD.id" :span="10">
            <el-input type="number" v-model="cashTransaction.usdRate" />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Note: " prop="note">
        <el-input type="textarea" v-model="cashTransaction.note" />
      </el-form-item>
    </el-form>

    <el-form v-if="!isBalanceOnly" :model="cashTransaction" :rules="rules" ref="formRef" label-width="150px"
      size="small">
      <el-form-item label="Date: " prop="date">
        <el-date-picker v-model="cashTransaction.date" type="datetime" placeholder="Pick a date and time"
          format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm:ss" />
      </el-form-item>
      <el-form-item v-show="cashTransaction.ctnxNo" label="Transaction No: ">
        <el-input v-model="cashTransaction.ctnxNo" disabled />
      </el-form-item>
      <el-form-item label="Customer Name: " prop="customerName">
        <div @click="modal.openCustomer()">
          <el-input v-model="cashTransaction.customerName" placeholder="Click to select customer" :disabled="isEdit" />
        </div>
      </el-form-item>
      <el-form-item label="Particular: " prop="particular">
        <el-input v-model="cashTransaction.particular" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="Branch:" prop="place">
        <el-select v-model="cashTransaction.place" placeholder="Select" :disabled="branchFieldDisabled">
          <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="For:">
        <el-select v-model="cashTransaction.tnxFor" :disabled="fieldDisabled">
          <el-option v-for="item in transactionFor.toList()" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="Reference: " prop="reference">
        <el-input v-model="cashTransaction.reference" :disabled="fieldDisabled" />
      </el-form-item>
      <el-form-item label="Cash In/Out">
        <el-select v-model="cashTransaction.io" :disabled="isEdit || fieldDisabled">
          <el-option v-for="item in cashIoType.toList()" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="Cash Category: " prop="cashCategoryId">
        <el-cascader v-model="cashTransaction.cashCategoryId" :options="cashCategoryList" :disabled="isEdit"
          style="width: 60%; max-width: 500px" :props="{ checkStrictly: true, label: 'name', value: 'id' }"
          filterable />
      </el-form-item>
      <el-row align="middle">
        <el-col :span="12">
          <el-form-item label="Account:" prop="cashAccName">
            <el-select style="width: 100%;" v-model="cashTransaction.cashAccId" @change="handleCashAccSelect"
              :disabled="isEdit" clearable filterable @clear="resetCashAcc">
              <el-option v-for="item in cashAccList" :key="item.id" :label="`${item.name} (${item.number})`"
                :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="cashTransaction.io == cashIoType.CashOut.id && !isEdit" :span="12">
          <el-form-item label="To Account:" prop="toCashAccName">
            <el-select style="width: 100%;" v-model="cashTransaction.toCashAccId" @change="handleToCashAccSelect"
              :disabled="isEdit" clearable filterable @clear="resetCashAcc">
              <el-option v-for="item in cashAccList" :key="item.id" :label="`${item.name} (${item.number})`"
                :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Amount: " prop="amount">
        <el-input type="number" v-model="cashTransaction.amount" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="Bank Transaction No: " prop="bankTransactionNo">
        <el-input type="number" v-model="cashTransaction.bankTransactionNo" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="Mode">
        <el-select v-model="cashTransaction.mode" disabled>
          <el-option v-for="item in cashTransactionMode.toList()" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="Currency">
        <el-select v-model="cashTransaction.prCurrency" disabled>
          <el-option v-for="item in cashCurrency.toList()" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="For Currency" prop="forCurrency">
        <el-row gutter="30">
          <el-col :span="8">
            <el-select style="min-width: 100px;" v-model="cashTransaction.forCurrency" :disabled="isEdit">
              <el-option v-for="item in usdMmkOption.toList().filter(o => [1, 2].includes(o.id))" :key="item.id"
                :label="item.name" :value="item.id" />
            </el-select>
          </el-col>
          <el-col v-if="cashTransaction.forCurrency == usdMmkOption.USD.id" :span="10">
            <el-input type="number" v-model="cashTransaction.usdRate" />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Note: " prop="note">
        <el-input type="textarea" v-model="cashTransaction.note" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="modal.closeCashTransaction()" size="small">Cancel</el-button>
      <el-button type="primary" @click="handleDialogConfirm" size="small">Confirm</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { ElMessageBox } from 'element-plus'
import { cashIoType, cashCurrency, cashTransactionMode, transactionFor, usdMmkOption, prCurrencyOptions } from '@/utils/constants'
import { validateLessThanZeroAmount } from '@/utils/validators'
import { getCurrencyLatestList } from '@/api/currency'
import myanmarNumToWord from 'myanmar-num-to-word'
import { useModalStore } from '@/stores/modal'
import { useShopDataStore } from '@/stores/shopData'
import { useUserStore } from '@/stores/user'
import { useLoading } from '@/composables/useLoading'
import { defaultCashTransaction } from './defaults'

const modal = useModalStore()
const shopDataStore = useShopDataStore()
const userStore = useUserStore()
// defaultBranch is on userStore, not shopDataStore
const { setLoading } = useLoading()
const formRef = ref(null)

const visible = ref(false)
const isBalanceOnly = ref(false)
const isEdit = ref(false)
const branchFieldDisabled = ref(false)
const fieldDisabled = ref(false)
const branchList = ref([])
const cashAccList = ref([])
const cashCategoryList = ref([])
const cashTransaction = ref({ ...defaultCashTransaction })

const requiredRule = () => [{ required: true, message: 'This field is required', trigger: 'blur' }]
const amountRules = [{ required: true, message: 'This field is required', trigger: 'blur' }, { validator: validateLessThanZeroAmount, trigger: 'blur' }]

const refRequiredTnxFor = new Set([
  transactionFor.OrderForm.id,
  transactionFor.Voucher.id,
  transactionFor.ReturnIn.id,
])

const balanceOnlyRules = {
  forCurrency: requiredRule(),
  amount: amountRules
}

const rules = computed(() => {
  if (isBalanceOnly.value) return { ...balanceOnlyRules }
  const refRequired = refRequiredTnxFor.has(cashTransaction.value.tnxFor)
  return {
    date: requiredRule(),
    forCurrency: requiredRule(),
    cashAccName: requiredRule(),
    amount: amountRules,
    place: requiredRule(),
    cashCategoryId: requiredRule(),
    ...(refRequired ? { reference: requiredRule() } : {}),
  }
})

// React to customer selection from CustomerDialog
watch(() => modal.customer.selected, (val) => {
  if (val && visible.value) {
    cashTransaction.value.customerName = val.name
    cashTransaction.value.customerId = val.id
  }
})

watch(() => modal.cashTransaction.visible, async (val) => {
  if (val) {
    try {
      setLoading(true)
      const usdRes = await getCurrencyLatestList()
      branchList.value = shopDataStore.branches
      cashAccList.value = shopDataStore.cashAccs
      cashCategoryList.value = shopDataStore.cashCategories

      const params = modal.cashTransaction.data
      isBalanceOnly.value = false
      isEdit.value = false
      fieldDisabled.value = false
      cashTransaction.value = { ...defaultCashTransaction }

      if (params) {
        cashTransaction.value = { ...params }
        isBalanceOnly.value = params.isBalanceOnly || false
        cashTransaction.value.cashCategoryId = findCascaderPath(cashCategoryList.value, cashTransaction.value.cashCategoryId)
        isEdit.value = cashTransaction.value.cashCategoryId != null && !isBalanceOnly.value
        fieldDisabled.value = true
      } else {
        cashTransaction.value.place = userStore.defaultBranch?.id
        cashTransaction.value.usdRate = usdRes.data.filter(item => item.code === prCurrencyOptions.USD.id)[0]?.latestSell | 0
        const defaultCashCategory = cashCategoryList.value.find(item => item.name === 'Cash Book')
        if (defaultCashCategory) {
          const childCategory = defaultCashCategory.children?.find(item => item.name === 'Sale')
          cashTransaction.value.cashCategoryId = [defaultCashCategory.id, childCategory?.id]
        }
      }

      branchFieldDisabled.value = true
      visible.value = true
      // nextTick(() => formRef.value?.clearValidate())
    } catch (e) {
      // error handled by request interceptor
    } finally {
      setLoading(false)
    }
  } else {
    visible.value = false
  }
}, { immediate: true })

function findCascaderPath(options, targetId) {
  if (isBalanceOnly.value) return targetId

  for (const item of options) {
    if (item.id === targetId) return [item.id]
    if (item.children) {
      const path = findCascaderPath(item.children, targetId)
      if (path) return [item.id, ...path]
    }
  }
  return null
}

function convertMMK(number, currency) {
  if (currency == usdMmkOption.USD.id)
    return myanmarNumToWord.convertToBurmeseWords(number) + ' ဒေါ်လာ'
  else
    return myanmarNumToWord.convertToBurmeseWords(number) + ' ကျပ်'
}

function handleCashAccSelect(id) {
  const acc = cashAccList.value.find(item => item.id === id)
  if (acc) {
    cashTransaction.value.cashAccName = `${acc.name} (${acc.number})`
    cashTransaction.value.mode = acc.mode
    cashTransaction.value.prCurrency = acc.prCurrency
  }
}

function handleToCashAccSelect(id) {
  const acc = cashAccList.value.find(item => item.id === id)
  if (acc) cashTransaction.value.toCashAccName = `${acc.name} (${acc.number})`
}

function resetCashAcc() {
  cashTransaction.value.toCashAccId = null
  cashTransaction.value.toCashAccName = null
}

function handleClose(done) {
  formRef.value?.clearValidate()
  isEdit.value = false
  modal.closeCashTransaction()
  done()
}

async function handleDialogConfirm() {
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid) return

  ElMessageBox.confirm(
    `Do you want to create a transaction with <span style="color:red; font-size:14px; font-weight:bold;">${convertMMK(Math.abs(cashTransaction.value.amount), cashTransaction.value.prCurrency)}.</span>`,
    'Warning', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    type: 'warning',
    dangerouslyUseHTMLString: true
  }).then(() => {

    if (!isBalanceOnly.value) {
      const selectedPath = cashTransaction.value.cashCategoryId
      cashTransaction.value.cashCategoryId = selectedPath?.[selectedPath.length - 1] ?? null
    }
    cashTransaction.value.branchCode = branchList.value.find(b => b.id === cashTransaction.value.place)?.branchCode
    // cashTransaction.value.employeeId = userStore.userId
    // cashTransaction.value.employeeName = userStore.name

    // Notify caller via modal store resolved data
    modal.cashTransaction.data = { ...cashTransaction.value, _validated: true }
    // modal.closeCashTransaction()
    // visible.value = false
  }).catch(() => { })
}
</script>

<style></style>
